import { UPDATE_SELECTED_SCHEMA } from '../constants';

export default function updateSelectedSchema(schemaType, value) {
    return { type: UPDATE_SELECTED_SCHEMA, payload: { schemaType, value } };
}
